import React from 'react';

const Notfound = () => {
    return (
        <div>
            <div style={{ minHeight: "80vh" }} className="d-flex align-items-center justify-content-center">
                <h1 className='text-center'>404! Not Found</h1>
            </div>
        </div>
    );
};

export default Notfound;